import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    data: null
};

export const setProgressBarData = (state = INITIAL_STATE, { data }) => {
    return { ...state, data };
};

export const setVisitedState = (state = INITIAL_STATE, { index, params }) => {
    const data = JSON.parse(JSON.stringify(state.data));
    data.forEach((item, currentIndex) => {
        //mark all previous items and children as visited
        if (currentIndex < index) {
            item.visited = true;
        }
        if (item.children && currentIndex < index) {
            Object.keys(item.children).forEach(element => {
                item.children[element] = true;
            });
        }
    });
    data[index][params] = true;
    return { ...state, data };
};

export const HANDLERS = {
    [Types.SET_PROGRESS_BAR_DATA]: setProgressBarData,
    [Types.SET_VISITED_STATE]: setVisitedState

};

export default createReducer(INITIAL_STATE, HANDLERS);
